import { breakpoints, pxToRem, scrollbar, themeGet, themeGetColor } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Section = styled.section `
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: auto;

  margin: ${themeGet('spacing.md')};
  margin-left: 0;

  background-color: ${themeGetColor('background.50')};

  border: ${pxToRem(1)} solid ${themeGet('colors.border.100')};
  border-radius: ${themeGet('borderRadius.md')};

  --screen-layout-sidebar-width: 100dvw;

  ${breakpoints.desktop} {
    --screen-layout-sidebar-width: 25dvw;
  }
`;
export const TopbarContainer = styled.header `
  display: flex;
  align-items: center;

  padding: ${themeGet('spacing.md')} ${themeGet('spacing.xl')};

  border-bottom: solid ${pxToRem(1)} ${themeGet('colors.border.100')};
`;
export const Main = styled.div `
  display: flex;
  position: relative;
  height: 100%;
  overflow: hidden;
`;
export const ContentContainer = styled.main `
  --screen-layout-content-width: ${(p) => p.$sidebarOpen ? 'calc(100dvw - var(--screen-layout-sidebar-width))' : '100dvw'};

  flex: 1 auto;
  width: 100%;

  padding: ${themeGet('spacing.lg')} ${themeGet('spacing.xl')};

  overflow: auto;
  ${scrollbar({ trackMargin: 'sm' })};

  transition: max-width 0.2s ease-in-out;

  ${breakpoints.lg} {
    max-width: var(--content-width);
  }
`;
export const SidebarInnerContainer = styled.div `
  display: flex;
  position: relative;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden auto;
  margin-right: ${themeGet('spacing.sm')};

  border-left: solid ${pxToRem(1)} ${themeGet('colors.border.100')};

  transition: transform 0.2s ease-in-out;

  ${scrollbar({ trackMargin: 'sm' })}

  ${breakpoints.desktop} {
    width: var(--screen-layout-sidebar-width);
  }
`;
export const SidebarContainer = styled.aside `
  position: absolute;
  width: 100dvw;
  height: 100%;
  overflow: hidden;

  top: 0;
  left: 0;
  background-color: ${themeGet('colors.background.50')};
  z-index: ${themeGet('zIndex.popover')};

  transition: transform 0.2s ease-in-out;

  transform: translateX(${(p) => (p.$open ? '0' : '100%')});

  ${breakpoints.desktop} {
    --screen-layout-sidebar-container-width: ${(p) => (p.$open ? 'var(--screen-layout-sidebar-width)' : '0')};
    position: sticky;
    flex-shrink: 0;
    width: var(--screen-layout-sidebar-container-width);
    transform: unset;
    transition: width 0.2s ease-in-out;
    z-index: unset;
  }
`;
